export function getFileExtension (path) {
  return path.substr(path.lastIndexOf('.') + 1).toLowerCase()
}

export function isValidImageFile (options, file, callback) {
  // Check file size.
  if (file.size / 1024 > options.maxFileSizeKb) {
    callback(false, `File is too large (max ${options.maxFileSizeKb}kB).`) // eslint-disable-line node/no-callback-literal
    return
  }

  // Check image format by file extension.
  const fileExtension = getFileExtension(file.name)
  if ($.inArray(fileExtension, options.allowedFormats) > -1) {
    callback(true, 'Image file is valid.') // eslint-disable-line node/no-callback-literal
  } else {
    callback(false, 'File type is not allowed.') // eslint-disable-line node/no-callback-literal
  }
}
